module.exports = __webpack_public_path__ + "img/policyNumIcon.3ea01563.png";